import Grid from '@mui/material/Grid2';
import React, { SetStateAction } from 'react';
import { UseFormWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import FileUpload from '../../../../../shared/components/FileUpload';
import { ImageHandler } from '../../../../../shared/components/ImageHandler';
import { EBackupImage } from '../../../../../shared/enums/shared/EBackupImage';
import { ETheme } from '../../../../../shared/enums/user/ETheme';
import { IFormField } from '../../../../../shared/interfaces/forms/IForms';
import { IUser } from '../../../../../shared/interfaces/user/IUser';
import { darkPalette, lightPalette } from '../../../../../shared/mui/palettes';
import { RootState } from '../../../../../store/store';

interface IProps {
  watch: UseFormWatch<IUser>;
  formFields: IFormField[];
  file: File | null;
  files: FileList | null;
  setFile: React.Dispatch<SetStateAction<File | null>>;
  setFiles: React.Dispatch<SetStateAction<FileList | null>>;
}

export const getFileType = (mime: string): EBackupImage => {
  if (mime?.includes('pdf')) {
    return EBackupImage.PDF;
  }
  return EBackupImage.OTHER;
};
const Documents = ({
  setFile,
  setFiles,
  file,
  files,
  formFields,
  watch,
}: IProps) => {
  const { t } = useTranslation();
  const { theme } = useSelector(
    (state: RootState) => state.auth.userData,
  ) as IUser;
  const onChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    isMultiple = false,
  ) => {
    const { files } = event.target;
    if (isMultiple) {
      setFiles(files);
    } else {
      setFile(files?.[0] as File);
    }
  };

  return (
    <>
      {formFields?.map((formField) => {
        const multiple = formField?.multiple;
        return (
          <React.Fragment key={formField?.key}>
            <Grid spacing={6} sx={{ marginBottom: '10px' }}>
              <FileUpload
                file={multiple ? file : files}
                label={t(formField?.label)}
                onChange={(e) => onChange(e, multiple)}
                multiple={formField?.multiple}
                fallbackType={
                  formField?.accept?.includes('application/pdf')
                    ? EBackupImage.PDF
                    : EBackupImage.OTHER
                }
                accept={formField?.accept}
              />
            </Grid>
            <Grid spacing={6} sx={{ marginBottom: '10px' }}>
              {multiple ? (
                <>
                  {watch('userDocuments')?.map((document) => {
                    return (
                      <ImageHandler
                        key={document?.id}
                        src={document?.path}
                        alt={`File preview - ${document?.id}`}
                        onClick={() => window.open(document?.path)}
                        className={'profile-backup-image'}
                        style={{
                          borderColor:
                            theme === ETheme.LIGHT
                              ? lightPalette.primary.light
                              : darkPalette.background.paper,
                        }}
                        tooltipTitle={document?.title || document?.name}
                        fallbackType={getFileType(document?.mime)}
                      />
                    );
                  })}
                </>
              ) : (
                watch('profilePhoto')?.path && (
                  <ImageHandler
                    src={String(watch('profilePhoto')?.path)}
                    alt="File preview"
                    onClick={() => window.open(watch('profilePhoto')?.path)}
                    className={`profile-backup-image`}
                    style={{
                      borderColor:
                        theme === ETheme.LIGHT
                          ? lightPalette.primary.light
                          : darkPalette.background.paper,
                    }}
                  />
                )
              )}
            </Grid>
          </React.Fragment>
        );
      })}
    </>
  );
};

export default Documents;
